// extracted by mini-css-extract-plugin
export default {"btnBox":"Od2uFSEvctw164OMu0dh"};